import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSnowNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M25.5 0v7l5.6-4.2 1.8 2.4-7.4 5.55v10.653l9.225-5.326 1.107-9.184 2.978.359-.837 6.95 6.062-3.5 1.5 2.597-6.062 3.5 6.437 2.75-1.178 2.76-8.507-3.635L27.001 24l9.224 5.325 8.506-3.633 1.179 2.759-6.437 2.75 6.062 3.5-1.5 2.598-6.062-3.5.837 6.95-2.979.358-1.106-9.183-9.225-5.326V37.25l7.4 5.55-1.8 2.4-5.6-4.2v7h-3v-7l-5.6 4.2-1.8-2.4 7.4-5.55V26.599l-9.224 5.326-1.107 9.183-2.978-.359.837-6.95-6.062 3.5-1.5-2.598 6.062-3.5-6.437-2.75 1.178-2.758 8.507 3.633L21 24l-9.226-5.326-8.506 3.633-1.179-2.759 6.438-2.75-6.063-3.5 1.5-2.598 6.063 3.5-.838-6.95 2.979-.358 1.106 9.183 9.225 5.326V10.75L15.1 5.2l1.8-2.4L22.5 7V0z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSnowNormalLarge;
